let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jlb9q")).then(() => parcelRequire('lbWy3'));